import {
  ButtonPrimeReact,
  CalendarPrimeReact,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"

export interface ModalCierreEjercicioProps {
  isOpen: boolean
  close: () => void
  handlePostFinantialClosingDates: (fiantialClosingDates: Date[]) => void
}

export const ModalCierreEjercicio = ({
  isOpen = false,
  close,
  handlePostFinantialClosingDates,
}: ModalCierreEjercicioProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const DEFAULT_DATES: Array<Date> = [
    new Date(`${new Date().getFullYear()}-01-01`),
    new Date(`${new Date().getFullYear()}-12-31`),
  ]
  const [fiantialClosingDates, setFiantialClosingDates] =
    useState<Date[]>(DEFAULT_DATES)

  const handleClose = () => {
    close()
    setFiantialClosingDates(DEFAULT_DATES)
  }

  const handleSubmit = () => {
    handlePostFinantialClosingDates(fiantialClosingDates)
    setFiantialClosingDates(DEFAULT_DATES)
  }

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-mb-6'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
            {t("mayor.modal.finantialClosing")}
          </p>
          <ButtonPrimeReact
            className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
            onClick={handleClose}
          >
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5'
            />
          </ButtonPrimeReact>
        </div>
      }
      // eslint-disable-next-line react/no-children-prop
      children={
        <>
          <div className='tw-w-full tw-flex tw-flex-col tw-text-base'>
            <p className='tw-mb-2'>
              <Trans
                i18nKey='mayor.modal.closingDates'
                components={[
                  <span
                    className='tw-font-medium tw-contents'
                    key='0'
                  />,
                ]}
              />
            </p>
            <CalendarPrimeReact
              id='fechaCierre'
              name='fechaCierre'
              value={fiantialClosingDates}
              locale={language}
              onChange={({ value }) => {
                if (value) {
                  setFiantialClosingDates(value as Date[])
                }
              }}
              selectionMode='range'
              placeholder='dd/mm/aaaa'
              dateFormat='dd/mm/yy'
              showIcon
            />
          </div>
        </>
      }
      footer={
        <div
          key='BotonesCierre'
          className='tw-flex tw-justify-end tw-items-center tw-mt-8'
        >
          <ButtonPrimeReact
            className='tw-p-6 !tw-bg-transparent !tw-text-primary !tw-border-0 tw-mr-4'
            onClick={handleClose}
          >
            {`${t("mayor.modal.cancelButton")}`}
          </ButtonPrimeReact>
          <ButtonPrimeReact
            className='tw-p-6 !tw-bg-primary tw-text-simple-10'
            type='submit'
            onClick={handleSubmit}
            disabled={fiantialClosingDates[1] === null}
          >
            {`${t("mayor.modal.confirmButton")}`}
          </ButtonPrimeReact>
        </div>
      }
    />
  )
}
